import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DropdownDTO } from "../../../types/common/DropdownDTO";

interface ITransportModeState {
  transportModeDropdown: DropdownDTO[];
}

const initialState: ITransportModeState = {
  transportModeDropdown: []
};

export const transportModeSlice = createSlice({
  name: 'transportMode',
  initialState,
  reducers: {
    loadingTransportModeDropdown: (state, action: PayloadAction<DropdownDTO[]>) => {
      state.transportModeDropdown = action.payload;
    },
  }
});

export const { loadingTransportModeDropdown } = transportModeSlice.actions;
export default transportModeSlice.reducer;
